export default __webpack_public_path__ + "static/media/govt-civic-mobile.6d60bbe4.jpg";